import Vue from 'vue'
import RecipientService from "../api/recipient"
import elasticlunr from 'elasticlunr'
import i18n from "../i18n"

import {deaccent} from '@/utils/text'

let index = elasticlunr(function () {
    this.setRef('irn')
    this.addField('NamLast')
    this.addField('NamFirst')
    this.addField('NamMiddle')
    this.addField('NamTitle')
    this.addField('MilRank')
    this.addField('MilService')
    this.addField('MilServiceComponent')
    this.addField('MilUnit')
    this.addField('BioServiceNumber')
    this.addField('BioBirthDate')
    this.addField('BioDeathDate')
    this.addField('BioBurialPlace')
    this.addField('NamSex')
    this.addField('MilBranch')
    this.addField('BioBirthPlace')
    this.addField('BioDeathPlace')

})

export const state = () => ({
    item: null,
    item_loading: false,
    list: [],
    list_results: [],
    list_loaded: false,
    list_loading: false
})

export const getters = {
    filter_province(state) {
        return i18n.t("filter_province")
    },
    filter_sex(state) {
        return i18n.t("filter_sex")
    },
    item(state) {
        return state.item
    },
    item_loading(state) {
        return state.item_loading
    },
    list(state) {
        return state.list_results
    },
    list_loading(state) {
        return state.list_loading
    }
}

export const actions = {
    async fetch_list({commit, state}, params) {
        if(state.list_loading || state.list_loaded) {
            return
        }

        commit('setListLoading', true)
        await RecipientService.all(params.locale)
            .then((response) => {
                commit('setList', response.data)
            })
            .catch((error) => {
                console.log(`Recipient API Error => ${error}`)
            })
    },
    async fetch({commit, state}, params) {
        if(state.item_loading) {
            return
        }

        commit('setItemLoading', true)
        await RecipientService.detail(params.locale, params.slug)
            .then((response) => {
                commit('setItem', response.data)
            })
            .catch((error) => {
                console.log(`Recipient API Error => ${error}`)
            })
    },
    async clear_search({commit, state}, params) {
        commit('resetSearch')
        return
    },
    async null_item({commit}) {
        commit('setItem', null);
    },
    async search({commit, state}, route) {
        if(!route) {
            commit('resetSearch')
            return
        }

        let results = state.list

        // Text Search
        if(route.q) {
            const q = deaccent(decodeURI(route.q))
            const search_results = index.search(q, {
                expand: true
            })

            // Remap Search Results
            const ids = search_results.map((result) => (
                parseInt(result.ref)
            ))
            results = results.filter((item) => (
                ids.includes(item.irn)
            ))
        }

        // Filter: Gender
        // if(route.gender) {
        //     const gender = decodeURI(route.gender)

        //     results = results.filter((item) => (
        //         item.NamSex === gender
        //     ))
        // }

        // // Filter: Province
        // if(route.province) {
        //     const province = decodeURI(route.province)

        //     results = results.filter((item) => (
        //         // .includes(theme)
        //     ))
        // }

        // Filter: Theme
        // if(route.theme) {
        //     const theme = decodeURI(route.theme).toLowerCase()

        //     results = results.filter((item) => (
        //         item.MilService_tab.includes(theme)
        //     ))
        // }

        commit('setSearchResults', results)
    }
}

export const mutations = {
    resetSearch(state) {
        state.list_results = state.list
    },
    setItem(state, data) {
        state.item = data
        state.item_loading = false
    },
    setItemLoading(state, loading) {
        state.item_loading = loading
    },
    setList(state, data) {
        data.forEach(item => {
            index.addDoc({
                'irn': item.irn,
                'NamLast': deaccent(item.NamLast),
                'NamFirst': deaccent(item.NamFirst),
                'NamMiddle': deaccent(item.NamMiddle),
                'NamTitle': deaccent(item.NamTitle),
                'MilRank': 'MilRank_tab' in item ? deaccent(item.MilRank_tab.join(" ")) : null,
                'MilService': 'MilService_tab' in item ? deaccent(item.MilService_tab.join(" ")) : null,
                'MilServiceComponent': 'MilServiceComponent_tab' in item ? deaccent(item.MilServiceComponent_tab.join(" ")) : null,
                'MilUnit': 'MilUnit_tab' in item ? deaccent(item.MilUnit_tab.join(" ")) : null,
                'BioServiceNumber': 'BioServiceNumber_tab' in item ? deaccent(item.BioServiceNumber_tab.join(" ")) : null,
                'BioBirthDate': deaccent(item.BioBirthDate),
                'BioDeathDate': deaccent(item.BioDeathDate),
                'BioBurialPlace': deaccent(item.BioBurialPlace),
                'NamSex': deaccent(item.NamSex),
                'MilBranch': 'MilBranch_tab' in item ? deaccent(item.MilBranch_tab.join(" ")) : null,
                'BioBirthPlace': deaccent(item.BioBirthPlace),
                'BioDeathPlace': deaccent(item.BioDeathPlace),
            })
        })

        state.list = data
        state.list_results = data
        state.list_loaded = true
        state.list_loading = false
    },
    setListLoading(state, loading) {
        state.list_loading = loading
    },
    setSearchResults(state, results) {
        state.list_results = results
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
